export default __webpack_public_path__ + "static/media/background_we_do.7fca0c86.png";